module.exports = __webpack_public_path__ + "static/media/semi-detached.5f92f5c4.png";